import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from "prop-types";
import {Redirect, Link} from 'react-router-dom';
import * as Actions from '../actions';
import queryString from 'query-string';
import lang from '../constants/Languages.js';
import {bindActionCreators, compose} from 'redux';

//import components
import AdvancedSearchSelect from '../components/advanced-search/AdvancedSearchSelect.js';
import AdvancedSearchForm from '../components/advanced-search/AdvancedSearchForm.js';
import PageHeader from '../components/PageHeader.js';
import LoadingIndicator from '../components/LoadingIndicator.js';
import LoadingError from '../components/LoadingError.js';
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';

//helper scripts
import SearchResultsQueryBuild from '../scripts/SearchResultsQueryBuild.js';
import withTitle from '../scripts/WithTitle.js';

//img
import arrowIcon from '../assets/icons/arrow-circle-empty-right.svg';
import arrowIconContrast from '../assets/icons/arrow-circle-empty-right-contrast.svg';

class AdvancedSearch extends Component {
    static defaultProps = {
        conjOptions: [ 'and', 'or' ],
        dates: ['year', 'date'],
        relationsDate: [ 'IN_RANGE', 'CONTAINS_ANYTHING', 'IS_EMPTY'],
        relations: [ 'CONTAINS', 'NOT_CONTAINS', 'CONTAINS_ANYTHING', 'IS_EMPTY' ],
    };

    constructor() {
        super();
        this.state = {
            fireRedirect: false,
            query: ''
        };
    };

    componentDidMount() {
        const {actions, activeTab} = this.props;
        actions.getActiveTabData(activeTab);
    };

    componentWillReceiveProps(nextProps) {
        //prevents unexpected redirect when going back
        if (nextProps.location !== this.props.location) {
            this.setState({fireRedirect: false});
        }
    };

    setActiveTab = (values) => {
        const {actions, activeTab, tabs} = this.props;

        if (activeTab !== values.value) {
            actions.setAdvancedSearchTab(values.value);
        }

        if (!tabs.filter(tab => tab.name === values.value && tab.data).length > 0) {
            actions.getActiveTabData(values.value);
        }
    };

    submitForm = (values) => {
        const {activeTab} = this.props;

        this.setState({
            fireRedirect: true,

            query: queryString.stringify({
                q: SearchResultsQueryBuild(values.searchQueries),
                area: activeTab
            }, {
                arrayFormat: 'index'
            })
        });
    };

    getTabData = (data) => {
        const {clang} = this.props;

        return data.map(option => { return {
                  ...option,
                  value: option.label,
                  label: lang[clang].advanced_search.search_field_options[option.label]
              }});
    };

    isDate = (type) => this.props.dates.includes(type);

    getRelation = (type) => {
         return this.isDate(type) ? this.props.relationsDate[0] : this.props.relations[0];
    };

    getAllRelations = (type) => {
         return this.isDate(type) ? this.props.relationsDate : this.props.relations;
    };

    render() {
        const {tabs, clang, isLoadingError, isLoading, location, activeTab, conjOptions} = this.props;
        const {query, fireRedirect} = this.state;
        const from = location.state || '/';
        const breadcrumbsList = [{label: 'home'}];
        const isLoggedIn = localStorage.getItem('user');
        const newTabs = tabs.filter(option => !(!isLoggedIn && option.logged)).map(tab => { return {value: tab.name, label: lang[clang].search.options_single[tab.name]}});

        return (
            <section className="advanced-search">
                <ItemBreadcrumbs list={breadcrumbsList} currentPage={lang[clang].headers.advanced_search}/>
                <PageHeader name={lang[clang].headers.advanced_search}/>
                {isLoadingError &&
                    <LoadingError />}

                {isLoading && !isLoadingError &&
                    <LoadingIndicator />}

                {!isLoading && !isLoadingError &&
                    <div className="advanced-search__inner">
                        <div className="advanced-search__main">
                            <AdvancedSearchSelect
                                advSearchOptions={newTabs}
                                defaultValue={activeTab}
                                setActiveTab={this.setActiveTab}/>

                            <div className="advanced-search__how">
                                <Link to={'/about/how-search'} className="advanced-search__how__link" title={lang[clang].advanced_search.how}>
                                    {lang[clang].advanced_search.how}
                                    <img src={arrowIcon} alt="" className="advanced-search__how__img"/>
                                    <img src={arrowIconContrast} alt="" className="advanced-search__how__img contrast"/>
                                </Link>
                            </div>

                            {tabs.map((tab, index) => tab.active && tab.data ?
                                <AdvancedSearchForm
                                    {...tab}
                                    data={this.getTabData(tab.data)}
                                    key={tab.id}
                                    onSubmit={this.submitForm}
                                    conjOptions={conjOptions}
                                    getRelation={this.getRelation}
                                    getAllRelations={this.getAllRelations}
                                    initialValues={{
                                        searchQueries: [{
                                                            attribute: this.getTabData(tab.data)[0],
                                                            innerFields: [{relation: this.getRelation(this.getTabData(tab.data)[0].type)}]
                                                        }]
                                    }}
                                    form={`advanced-search-${tab.name}`} />
                                : false)}

                            {fireRedirect &&
                                <Redirect push to={{
                                    pathname: '/advanced-results',
                                    search: `?${query}`,
                                    state: {
                                        referrer: from
                                    }
                                }}/>}
                        </div>
                    </div>}
            </section>
        );
    };
};

AdvancedSearch.propTypes = {
    tabs: propTypes.arrayOf(
        propTypes.shape({
            id: propTypes.number.isRequired,
            name: propTypes.string.isRequired,
            active: propTypes.bool
        })
    ),
    activeTab: propTypes.string.isRequired,
    isLoading: propTypes.bool.isRequired,
    isLoadingError: propTypes.bool.isRequired,
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    tabs: state.advancedSearch.tabs,
    activeTab: state.advancedSearch.activeTab,
    clang: state.language.currentLanguage,
    isLoading: state.advancedSearch.isFetching,
    isLoadingError: state.advancedSearch.isLoadingError,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(AdvancedSearch);



// WEBPACK FOOTER //
// ./src/containers/AdvancedSearch.js